import type { InputHTMLAttributes } from "react";
import { cx } from "../utils/cx";
import styles from "./TextInput.module.css";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Marks the field invalid — sets aria-invalid and the error border. */
  invalid?: boolean;
}

/**
 * The KCC text input. Selects and textareas share the same visual baseline
 * (style-guide.md: Input Elements). Validation state is driven by
 * `aria-invalid`, not a CSS class, so it reaches assistive technology.
 */
function TextInput({ invalid, className, type = "text", ...rest }: TextInputProps) {
  return (
    <input
      type={type}
      aria-invalid={invalid || undefined}
      className={cx(styles.input, className)}
      {...rest}
    />
  );
}

export default TextInput;
